export const FORM_VACANCY_NAMES = {
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    EMAIL: 'email',
    PHONE: 'phone',
    ENGLISH_LEVEL: 'englishLevel',
    COUNTRY: 'country',
    CV: 'cv',
    LINKEDIN: 'linkedIn',
    INFORMATION: 'information',
    PRIVACY_POLICY: 'privacyPolicy',
    SUBMIT_TASK: 'submitTask',
    NAME_OF_AGENCY: 'nameOfAgency',
    AGENCY_ID: 'agencyID',
    AGENCY_EMAIL: 'agencyEmail',
    CONTACT_PERSON: 'contactPerson',
    AGENCY_FEEDBACK: 'agencyFeedback',
};
